import * as React from 'react';

import EnterprisePageHeader from 'bundles/composable-page-header-enterprise/header-renderers/EnterprisePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import EnterpriseModalManager from 'bundles/unified-common/components/EnterpriseModalManager';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

type Props = {
  children: React.ReactNode;
  hideFooterTopBanner?: boolean;
};

/*
Use this to add the header/footer to a page in the enterprise context.

Ensure this is nested beneath the following providers: bundles/unified-common/providers/EnterpriseProductFeaturesDataProvider,
bundles/unified-common/providers/EnterpriseProgramDataProvider and bundles/unified-common/providers/ThirdPartyOrganizationDataProvider.
*/
const EnterpriseHeaderFooterWrapper = ({ children, hideFooterTopBanner }: Props) => {
  const program = useProgram();
  const thirdPartyOrg = useThirdPartyOrganization();

  return (
    <React.Fragment>
      <EnterprisePageHeader backupProgram={program} backupThirdPartyOrg={thirdPartyOrg} />
      <UniversalPageFeatures authModalOptions={{ isEnterprise: true, programId: program?.id }} />
      <main>{children}</main>
      <PageFooter hideTopBorder={hideFooterTopBanner} />
      <EnterpriseModalManager />
    </React.Fragment>
  );
};

export default EnterpriseHeaderFooterWrapper;
